export default function () {
  $(document).ready(function () {
  // Horizontally scroll the breadcrumbs bar to the end if there's overflow
    $('.breadcrumbs ol').scrollLeft(10000000)
    $('.breadcrumbs ul').scrollLeft(10000000)
  })
}
